// Central content config for NECOS.FM. Edit copy, flags and credits here.

// Verified facts only (approved by NECOS.FM).
export const SHOW_STATS = true;

export const STATS = [
  { value: "75%", label: "of issues resolved by telephone triage without a contractor attending", note: "NECOS reported" },
  { value: "24/7/365", label: "emergency support, every day of the year" },
  { value: "1", label: "point of contact for every workstream" },
];

export const SITE_URL = "https://necosfm.com";

export const COMPANY = {
  name: "NECOS.FM Ltd",
  long: "Nationwide Emergency Call Out Services",
  number: "16030384",
  address: ["71-75 Shelton Street", "Covent Garden", "London", "WC2H 9JQ"],
  headOffice: ["Riverview Office", "Harleyford Estate", "Henley Road", "Marlow", "SL7 2DX"],
  hotline: "0247 5222 999",
  hotlineTel: "tel:+442475222999",
  enquiries: "0247 5222 999, option 1",
  enquiriesTel: "tel:+442475222999",
  enquiriesHours: "Mon–Fri, 8am–6pm",
  email: "support@necos.fm",
  gasLine: "0800 111 999",
  gasTel: "tel:08001119999",
};

export const PORTALS = [
  { label: "Client Portal", href: "https://necos.app", id: "client" },
  { label: "Contractor Portal", href: "https://necos.app", id: "contractor" },
  { label: "Admin Login", href: "https://necos.app", id: "admin" },
];

export const NAV = [
  {
    id: "about",
    label: "About",
    items: [
      { label: "About NECOS", to: "/about", desc: "Who we are and how we work" },
      { label: "Our Commitment", to: "/about/commitment", desc: "Eight promises we keep" },
      { label: "Our Process", to: "/about/process", desc: "From first call to final report" },
      { label: "FAQ", to: "/about/faq", desc: "Straight answers" },
      { label: "Packages", to: "/about/packages", desc: "Plans priced on application" },
    ],
  },
  {
    id: "emergency",
    label: "Emergency Call-Out",
    items: [
      { label: "Emergency Call-Out", to: "/emergency-call-out", desc: "24/7 response, nationwide" },
      { label: "Our Triage Service", to: "/emergency-call-out/triage", desc: "Real people, calm guidance" },
      { label: "Areas We Cover", to: "/areas", desc: "UK cities and surrounding areas" },
      { label: "Report an Issue", to: "/report", desc: "Tell us what's happened", urgent: true },
    ],
  },
  {
    id: "fm",
    label: "Facilities Management",
    mega: true,
    items: [
      { label: "FM overview", to: "/facilities-management", desc: "One partner. One platform. Complete control." },
      { label: "Reactive Maintenance", to: "/facilities-management/reactive-maintenance", desc: "Day-to-day repairs, end to end" },
      { label: "Emergency & Make-Safe", to: "/facilities-management/emergency-make-safe", desc: "24/7/365 incident response", urgent: true },
      { label: "Out of Hours", to: "/facilities-management/out-of-hours", desc: "White-label evening & weekend cover" },
      { label: "Planned Maintenance", to: "/facilities-management/planned-maintenance", desc: "A structured programme" },
      { label: "Compliance", to: "/facilities-management/compliance", desc: "Inspections, records, remedials" },
      { label: "Cleaning", to: "/facilities-management/cleaning", desc: "Routine to specialist" },
      { label: "Voids & Refurbishment", to: "/facilities-management/voids-refurbishment", desc: "Inspection to handback" },
      { label: "Property Maintenance", to: "/facilities-management/property-maintenance", desc: "Fabric, external, specialist" },
      { label: "Sectors", to: "/facilities-management/sectors", desc: "Who we support" },
      { label: "NECOS.APP", to: "/facilities-management/necos-app", desc: "The client platform" },
    ],
  },
  {
    id: "join",
    label: "Join Us",
    items: [
      { label: "Clients", to: "/clients", desc: "For landlords and property managers" },
      { label: "Contractors", to: "/contractors", desc: "Join our vetted network" },
    ],
  },
  { id: "contact", label: "Contact", to: "/contact" },
];

export const LEGAL_LINKS = [
  { label: "Privacy Policy", to: "/legal/privacy" },
  { label: "Social Responsibility", to: "/legal/social-responsibility" },
  { label: "Modern Slavery Policy", to: "/legal/modern-slavery" },
  { label: "Cookies Policy", to: "/legal/cookies" },
  { label: "Personal Data Policy", to: "/legal/personal-data" },
  { label: "Contractor Terms", to: "/legal/contractor-terms" },
];

export const TRADES = ["Plumbing", "Electrical", "Locksmith", "Glazing", "Drainage", "Gated Access", "Heating & Hot Water", "Roofing", "Carpentry", "HVAC"];

export const STORY = [
  {
    id: "call",
    n: "01",
    time: "02:14",
    title: "The Call",
    copy: "Water through the ceiling. Your tenant dials one number, and a trained call handler answers — nights, weekends and bank holidays included.",
    img: "/images/story-call-sm.webp",
    alt: "A smartphone ringing on a bedside table at night, lit gold",
  },
  {
    id: "triage",
    n: "02",
    time: "02:17",
    title: "Triage",
    copy: "We assess urgency and risk, then talk the caller through safe self-help steps. Many issues are made safe over the phone — no call-out required.",
    img: "/images/story-triage-sm.webp",
    alt: "Call handlers wearing headsets in a dim control room",
  },
  {
    id: "dispatch",
    n: "03",
    time: "02:26",
    title: "Dispatch",
    copy: "If an engineer is needed, we match the job to a vetted local contractor with the right trade — fully briefed before they set off.",
    img: "/images/story-dispatch-sm.webp",
    alt: "A service van driving along a wet country road at night",
  },
  {
    id: "onsite",
    n: "04",
    time: "03:05",
    title: "On Site",
    copy: "The engineer arrives, assesses, explains the fix and makes the property safe — with quality materials, to a standard we stand behind.",
    img: "/images/story-onsite-sm.webp",
    alt: "An engineer with a head torch repairing pipework under a sink",
  },
  {
    id: "fixed",
    n: "05",
    time: "03:48",
    title: "Fixed & Reported",
    copy: "Job closed. You receive a clear report: the work carried out, the costs, and any recommendations for future maintenance.",
    img: "/images/story-fixed-sm.webp",
    alt: "A calm hallway at dawn with a tablet showing a completed checklist",
  },
];

export const CITIES = [
  ["London", -0.13, 51.5], ["Birmingham", -1.9, 52.48], ["Manchester", -2.24, 53.48], ["Leeds", -1.55, 53.8],
  ["Glasgow", -4.25, 55.86], ["Edinburgh", -3.19, 55.95], ["Bristol", -2.59, 51.45], ["Cardiff", -3.18, 51.49],
  ["Newcastle", -1.61, 54.97], ["Liverpool", -2.98, 53.41], ["Belfast", -5.93, 54.6], ["Aberdeen", -2.1, 57.15],
  ["Inverness", -4.22, 57.48], ["Plymouth", -4.14, 50.39], ["Southampton", -1.4, 50.91], ["Norwich", 1.29, 52.63],
  ["Nottingham", -1.15, 52.95], ["Sheffield", -1.47, 53.38], ["Cambridge", 0.12, 52.2], ["Exeter", -3.53, 50.72],
  ["Swansea", -3.94, 51.62], ["Hull", -0.33, 53.74], ["Dundee", -2.97, 56.46], ["Brighton", -0.14, 50.83],
  ["Leicester", -1.13, 52.63], ["Oxford", -1.26, 51.75], ["York", -1.08, 53.96], ["Carlisle", -2.94, 54.89],
];

export const PILLARS = [
  { title: "Quality you can trust", copy: "Every contractor is vetted for qualifications, insurance and track record before they ever reach your door." },
  { title: "Fast, reliable response", copy: "Calls are answered around the clock, triaged immediately and dispatched to local trades who know the area." },
  { title: "Transparent pricing", copy: "Clear, upfront estimates before work begins. No hidden fees, no surprises on the invoice." },
  { title: "One point of contact", copy: "One number for every property in your portfolio. No chasing multiple contractors — we coordinate it all." },
];

export const AUDIENCES = [
  { title: "Build-to-rent", copy: "Round-the-clock resident support that protects your reputation and keeps occupancy strong." },
  { title: "Corporate landlords", copy: "Consistent standards and reporting across every asset, wherever it sits in the UK." },
  { title: "Property managers", copy: "An out-of-hours desk that triages first, so you only pay for the call-outs that matter." },
  { title: "Letting agents", copy: "A dependable emergency line for your tenants — and fewer 3am calls for your team." },
];

export const FM_SERVICES = [
  { id: "building", title: "Building Maintenance & Repairs", icon: "Hammer", copy: "From routine upkeep to urgent fixes — roofing, plumbing, carpentry and minor works — plus regular inspections that catch issues before they escalate." },
  { id: "hvac", title: "HVAC & Mechanical", icon: "Fan", copy: "Specialists who maintain, repair and optimise heating, ventilation and air-conditioning to control costs, conserve energy and extend equipment life." },
  { id: "electrical", title: "Electrical & Lighting", icon: "Zap", copy: "Installation, testing and maintenance that keeps premises safe and compliant — from lighting upgrades to emergency lighting checks and certification." },
  { id: "cleaning", title: "Cleaning & Hygiene", icon: "Sparkles", copy: "General and specialist cleaning for offices, industrial sites, healthcare settings and more — because clean spaces work better." },
  { id: "grounds", title: "Grounds & Landscaping", icon: "Trees", copy: "Lawn care, garden maintenance and winter gritting that keep outdoor areas safe, presentable and well kept." },
  { id: "security", title: "Security", icon: "ShieldCheck", copy: "Working with security experts to provide manned guarding, CCTV, access control and perimeter protection." },
  { id: "compliance", title: "Compliance and Health & Safety", icon: "ClipboardCheck", copy: "Audits, risk assessments and ongoing guidance to keep you compliant with current legislation, including fire safety and health & safety." },
  { id: "energy", title: "Energy Management & Sustainability", icon: "Leaf", copy: "Strategies and technologies that optimise energy use, reduce costs and help meet your corporate social responsibility goals." },
];

export const FM_SECTORS = [
  "Commercial & office buildings", "Industrial warehouses & plants", "Educational campuses & institutions",
  "Healthcare & medical facilities", "Retail & hospitality venues", "Government buildings & public spaces",
];

export const EMERGENCY_TRADES = [
  { title: "Plumbing", icon: "Droplets", copy: "Burst pipes, leaks and failed supplies." },
  { title: "Locksmith", icon: "KeyRound", copy: "Lock-outs, broken locks and lock changes." },
  { title: "Electrical", icon: "Zap", copy: "Power loss, faults and unsafe installations." },
  { title: "Glazing", icon: "PanelTop", copy: "Broken windows and boarding up." },
  { title: "Drainage", icon: "Waves", copy: "Blockages, backflow and overflowing drains." },
  { title: "Gated Access", icon: "DoorOpen", copy: "Failed gates, barriers and entry systems." },
];

export const VALUES_CORE = [
  { title: "Reliability", sub: "Dependable in every situation", copy: "Emergencies don't keep office hours. We're available 24/7 so customers can always rely on a swift, efficient response." },
  { title: "Quality", sub: "Excellence in craft", copy: "Carefully vetted contractors deliver lasting, high-standard solutions on every call-out." },
  { title: "Customer-centric", sub: "Putting you first", copy: "Personal care, a real understanding of your needs, and solutions shaped around your property." },
  { title: "Integrity", sub: "Honest and transparent", copy: "Clear, upfront pricing and honest communication, so you always know what to expect." },
  { title: "Speed", sub: "Quick action, less damage", copy: "Fast action minimises damage and disruption — and gets life back to normal sooner." },
  { title: "Collaboration", sub: "Working as one", copy: "Our team, our contractors and our customers working together for a seamless service." },
  { title: "Accountability", sub: "Owning the outcome", copy: "Everyone on a job is accountable for their work. When we promise, we follow through." },
  { title: "Sustainability", sub: "Caring for the future", copy: "Sustainable practices that minimise our footprint while delivering reliable results." },
];

export const WHY_US = [
  { title: "24/7 availability", copy: "Emergencies don't wait for business hours, and neither do we." },
  { title: "Expert contractors", copy: "A network of fully vetted, experienced professionals." },
  { title: "Nationwide reach", copy: "Every corner of the UK — from Land's End to John o' Groats." },
  { title: "Fast response", copy: "Quick dispatch and decisive action to keep disruption to a minimum." },
  { title: "Fair pricing", copy: "Transparent quotes and no hidden fees — honest pricing for work performed." },
];

export const COMMITMENTS = [
  { title: "Reliability and availability", sub: "Always there when you need us", copy: "Day, night or weekend, we're available 24/7 — so you can count on us whenever something goes wrong." },
  { title: "Fast, efficient response", sub: "Quick action, minimal disruption", copy: "Once you reach out, we assess the situation and dispatch a local, qualified contractor without delay." },
  { title: "Local expertise, nationwide reach", sub: "Trusted contractors in your community", copy: "National coverage delivered by professionals embedded in their communities, with a genuinely local touch." },
  { title: "Quality workmanship", sub: "High standards on every job", copy: "Contractors vetted for skill, professionalism and customer care. We believe in doing it right the first time." },
  { title: "Clear, transparent pricing", sub: "No surprises, just fair rates", copy: "A clear, upfront estimate before any work begins — competitive rates with no hidden fees or unexpected charges." },
  { title: "Customer satisfaction", sub: "Your peace of mind comes first", copy: "Professionalism and respect from first contact to job complete. We build long-term relationships on dependable service." },
  { title: "Ongoing support", sub: "Here after the job is done", copy: "Questions, follow-up repairs or advice — our support continues long after the engineer has left." },
  { title: "Trust and long-term partnership", sub: "A service you can rely on", copy: "We aim to be more than a one-off provider: a trusted partner earning your confidence on every call-out." },
];

export const PROCESS = [
  { stage: "Emergency request", steps: [
    { title: "Reach out for help", copy: "Contact us 24/7 by phone or through the Client Portal. Tell us what's happened, where, and anything else we should know." },
  ] },
  { stage: "Assessment & dispatch", steps: [
    { title: "Assessing the situation", copy: "Our trained call handlers assess urgency and first check whether the issue can be resolved safely with guided self-help. If a visit is needed, we match a local, qualified contractor by trade and availability." },
    { title: "Contractor dispatch", copy: "The assigned contractor receives every detail and heads to the property. We monitor and coordinate progress in real time." },
  ] },
  { stage: "On-site arrival & evaluation", steps: [
    { title: "Contractor arrival", copy: "The contractor assesses the issue, discusses it on site and explains the repair required. The priority: make it safe, efficiently and to a high standard." },
    { title: "Immediate action", copy: "Where the issue can be resolved on site, work begins straight away. If parts or specialist tools are needed, next steps are communicated clearly." },
  ] },
  { stage: "Repair & resolution", steps: [
    { title: "Timely repairs", copy: "Repairs are carried out with the property owner kept informed throughout. For larger works, the contractor sets out next steps and a clear timeline." },
    { title: "Quality assurance", copy: "A final inspection confirms everything is fixed and functioning, followed by a summary of the work and any recommendations." },
  ] },
  { stage: "Payment & feedback", steps: [
    { title: "Transparent billing", copy: "Payment is processed securely. You only pay for the work performed, with clear pricing and no hidden fees." },
    { title: "Customer feedback", copy: "We ask for your feedback after every job — it's how we keep standards high for clients and contractors alike." },
  ] },
  { stage: "Ongoing support", steps: [
    { title: "Continuous support", copy: "If anything else arises, or follow-up is needed, we're a call away. Long-term peace of mind is the point." },
  ] },
];

export const FAQS = [
  { q: "What types of emergencies do you handle?", a: "A wide range of property emergencies — plumbing issues such as burst pipes and leaks, electrical faults, heating failures, lock-outs, glazing, drainage and more. If you smell gas, leave the property and call the National Gas Emergency line on 0800 111 999 first." },
  { q: "How quickly can someone attend?", a: "It depends on the nature of the issue and your service level. Our call handlers are available 24/7 to triage and, where a visit is needed, dispatch a local contractor from our nationwide network as quickly as possible." },
  { q: "How do I report an issue?", a: "Call our 24/7 hotline on 0247 5222 999, or log it through the Client Portal. Both are monitored around the clock." },
  { q: "How do I access the Client Portal?", a: "Clients can sign in to the Client Portal at necos.app — also linked from our site header — at any time to report issues and follow progress. Contact support@necos.fm if you need an account." },
  { q: "Do you cover all areas of the UK?", a: "Yes. We provide nationwide coverage through a trusted network of local contractors, wherever your property is located." },
  { q: "Are your contractors vetted and qualified?", a: "Yes. Every contractor in our network is vetted and must meet strict requirements, including relevant certifications, insurance and a proven track record for quality and reliability." },
  { q: "What if an emergency happens outside business hours?", a: "Our emergency service runs 24/7, including weekends and bank holidays. Call the hotline at any time." },
  { q: "What does the call-out fee include?", a: "The call-out fee typically covers the contractor's visit and an initial assessment. Any further repairs or services are quoted separately." },
  { q: "Can I decline your contractor's work after their assessment?", a: "You're under no obligation to proceed with repairs after an assessment. The initial call-out fee is non-refundable, as it covers the contractor's time and travel." },
  { q: "How can I track the status of my issue?", a: "Once reported, you can follow progress through the Client Portal and will receive updates as it's resolved. When the job is complete, we send a report covering the work carried out, associated costs and any maintenance recommendations." },
  { q: "Do you offer any service guarantees?", a: "We hold every repair to a high standard. If you're not satisfied with the quality of work, contact us straight away and we'll follow up." },
  { q: "What happens if the issue recurs after a repair?", a: "Warranties apply to most repairs. If a problem persists, we'll send a contractor back to reassess and resolve it at no additional cost — subject to warranty conditions and excluding tenant damage or misuse." },
];

export const TRIAGE_WHY = [
  { title: "24/7 availability", copy: "Middle of the night or a bank holiday — we're ready." },
  { title: "Immediate expert guidance", copy: "Experienced handlers assess the situation and advise on the spot." },
  { title: "Comprehensive coverage", copy: "A broad range of property emergencies, handled end to end." },
  { title: "Peace of mind", copy: "Knowing professional help is a call away changes everything." },
  { title: "Professional, courteous service", copy: "Highly skilled people who care about the caller's experience." },
  { title: "Cost-effective", copy: "The right steps taken early mitigate damage and avoid unnecessary call-out charges." },
];

export const TRIAGE_ISSUES = [
  { title: "Plumbing", items: ["Leaking pipes", "Blocked toilets", "Blocked pipes"] },
  { title: "Electrical", items: ["Tripped breakers", "Blown fuses", "Lighting", "Power outages"] },
  { title: "Heating & hot water", items: ["Boiler issues", "Thermostats", "Heating controls"] },
  { title: "Appliances", items: ["Hob / oven", "Washer / dryer", "Fridge / freezer", "Dishwasher"] },
];

export const CLIENT_BENEFITS = [
  { title: "24/7 peace of mind", copy: "Round-the-clock support and a rapid triage service mean you're never caught off guard." },
  { title: "Network of local contractors", copy: "A vetted, nationwide supply chain puts the right expert on site, wherever your property is." },
  { title: "Cost-effective solutions", copy: "Acting quickly stops minor issues becoming major costs. Triage puts resources where they matter." },
  { title: "Streamlined communication", copy: "A single point of contact and regular updates — no chasing multiple contractors." },
  { title: "Enhanced tenant satisfaction", copy: "Prompt, professional handling builds confidence and protects your reputation." },
  { title: "Compliance & quality assurance", copy: "Contractors are vetted, qualified, insured and work to strict safety and regulatory standards." },
];

export const CONTRACTOR_BENEFITS = [
  { title: "Consistent work", copy: "Access to emergency jobs in your area around the clock. The most reliable contractors earn more work." },
  { title: "Reliable payment", copy: "Fair, transparent rates, clear invoicing and payment on time." },
  { title: "A streamlined platform", copy: "Job assignment, billing and communication in one tech-driven system — so you can focus on the work." },
  { title: "24/7 support", copy: "Our support team is on hand around the clock for scheduling, queries and operational issues." },
  { title: "Room to grow", copy: "Scale your business by taking on more projects and expanding your services." },
  { title: "Training & resources", copy: "Online resources on best practice, safety standards and customer care." },
];

export const ONBOARDING = [
  { title: "Apply", copy: "Share your business details, certifications and relevant experience." },
  { title: "Vetting", copy: "We review your credentials, services and areas of expertise, and check your work history and reputation." },
  { title: "Onboard", copy: "Complete our onboarding training covering policies, platform use, safety procedures and emergency-response best practice." },
];

export const IMAGE_CREDITS = {
  aiGenerated: [
    "hero-night", "story-call", "story-triage", "story-dispatch", "story-onsite", "story-fixed", "fm-building", "tools",
    "city-night", "fm-reactive", "fm-emergency", "fm-ooh", "fm-planned", "fm-compliance", "fm-cleaning", "fm-voids",
    "fm-property", "fm-sectors", "fm-pro",
  ],
  stock: [
    { file: "stock-electrician", source: "Unsplash", author: "Emmanuel Ikwuegbu", url: "https://unsplash.com/photos/_2AlIm-F6pw" },
    { file: "stock-tradesperson", source: "Unsplash", author: "Emmanuel Ikwuegbu", url: "https://unsplash.com/photos/zWOgsj3j0wA" },
    { file: "stock-panel-test", source: "Unsplash", author: "colsan ltda", url: "https://unsplash.com/photos/LMb98OOtoYU" },
    { file: "stock-panel-work", source: "Unsplash", author: "Raze Solar", url: "https://unsplash.com/photos/GXLPLG3_Vf4" },
  ],
};

export const META = {
  "/": { title: "NECOS.FM | Responsive, Reliable, Professional", description: "24/7 emergency call-out, telephone triage and facilities management for build-to-rent, corporate landlords and property managers across the UK." },
  "/about": { title: "About | NECOS.FM", description: "A nationwide emergency call-out service with local expertise — built for landlords, property managers and the tenants they look after." },
  "/about/commitment": { title: "Our Commitment | NECOS.FM", description: "Eight promises: reliability, speed, local expertise, quality, transparent pricing, satisfaction, ongoing support and long-term partnership." },
  "/about/process": { title: "Our Process | NECOS.FM", description: "How an emergency call-out works with NECOS.FM, from first call to final report." },
  "/about/faq": { title: "FAQ | NECOS.FM", description: "Answers to common questions about our 24/7 emergency call-out and triage service." },
  "/about/packages": { title: "Packages | NECOS.FM", description: "Tailored plans for build-to-rent, corporate landlords and property managers. Pay per call-out or per unit, priced on application." },
  "/emergency-call-out": { title: "24/7 Emergency Call-Out | NECOS.FM", description: "A 24-hour call centre, telephone triage and a nationwide network of trusted local contractors." },
  "/emergency-call-out/triage": { title: "Telephone Triage Service | NECOS.FM", description: "Real, empathetic people guiding callers through safe self-help to avoid unnecessary contractor call-outs." },
  "/report": { title: "Report an Issue | NECOS.FM", description: "Report a property issue to NECOS.FM. For emergencies call 0247 5222 999 now." },
  "/facilities-management": { title: "Facilities Management | NECOS.FM", description: "Integrated, nationwide facilities management: reactive, emergency, out of hours, planned, compliance, cleaning, voids and NECOS.APP — one point of contact." },
  "/facilities-management/reactive-maintenance": { title: "Reactive Maintenance | NECOS.FM", description: "Day-to-day repairs coordinated end to end: diagnosis, allocation, approval, completion, evidence and commercial close-out." },
  "/facilities-management/emergency-make-safe": { title: "Emergency & Make-Safe — 24/7/365 | NECOS.FM", description: "Trained call handling, triage, rapid mobilisation and make-safe action across water, electrical, gas, weather, security and hygiene incidents." },
  "/facilities-management/out-of-hours": { title: "Out of Hours Property Support — White-label | NECOS.FM", description: "18:00–06:00 weekdays plus weekends and bank holidays. Triage first, dispatch second. Example prices from 50p per property per month." },
  "/facilities-management/planned-maintenance": { title: "Planned & Preventative Maintenance | NECOS.FM", description: "A structured programme, not a list of call-outs. Property, M&E, fabric and environment programmes that extend asset life." },
  "/facilities-management/compliance": { title: "Health, Safety & Compliance | NECOS.FM", description: "Fire, electrical, gas, water and governance compliance with a closed-loop process from plan to record." },
  "/facilities-management/cleaning": { title: "Cleaning & Specialist Services | NECOS.FM", description: "Communal, void, deep, emergency, external and grounds cleaning, connected to your wider maintenance." },
  "/facilities-management/voids-refurbishment": { title: "Voids & Refurbishment | NECOS.FM", description: "Inspection, works, evidence and handback — void and refurbishment turnaround by one accountable team." },
  "/facilities-management/property-maintenance": { title: "Property Maintenance | NECOS.FM", description: "Roofing, glazing, damp, grounds, external cleaning and general building support." },
  "/facilities-management/sectors": { title: "Sectors | NECOS.FM", description: "Residential and managed property, commercial, industrial, education, healthcare, public sector and retail estates." },
  "/facilities-management/necos-app": { title: "NECOS.APP — Client Platform | NECOS.FM", description: "Manage your portfolio, jobs, quotes, approvals, completion evidence and invoices in one controlled environment." },
  "/areas": { title: "Areas We Cover — 24/7 Emergency Repairs Across the UK | NECOS.FM", description: "24/7 emergency plumbing, electrical, locksmith and heating call-outs in cities across the UK. One number, central triage and a nationwide network of vetted local contractors." },
  "/clients": { title: "For Clients | NECOS.FM", description: "Hassle-free property emergency management for landlords and property management companies." },
  "/contractors": { title: "For Contractors | NECOS.FM", description: "Join a vetted nationwide network of trades delivering emergency call-out work in your area." },
  "/contractors/apply": { title: "Supplier Application | NECOS.FM", description: "Complete the form below to apply to join the NECOS.FM supplier network." },
  "/contractors/update": { title: "Update Your Supplier Details | NECOS.FM", description: "Existing NECOS.FM suppliers can request a secure link to update their details." },
  "/request-callout": { title: "Request a Call-Out | NECOS.FM", description: "Not an emergency? Request a call-out and we'll prioritise it accordingly." },
  "/contact": { title: "Contact | NECOS.FM", description: "Contact NECOS.FM. 24/7 emergency hotline 0247 5222 999, general enquiries 0247 5222 999 (option 1), support@necos.fm." },
  "/downloads": { title: "Downloads — Services & Out of Hours Brochures | NECOS.FM", description: "Get the NECOS.FM Services Brochure and the NECOS.FM Out of Hours Services Brochure, emailed to your inbox." },
  "/legal/privacy": { title: "Privacy Policy | NECOS.FM", description: "Privacy Policy for NECOS.FM Ltd." },
  "/legal/social-responsibility": { title: "Social Responsibility | NECOS.FM", description: "Social Responsibility statement for NECOS.FM Ltd." },
  "/legal/modern-slavery": { title: "Modern Slavery Policy | NECOS.FM", description: "Modern Slavery Policy for NECOS.FM Ltd." },
  "/legal/cookies": { title: "Cookies Policy | NECOS.FM", description: "Cookies Policy for NECOS.FM Ltd." },
  "/legal/personal-data": { title: "Personal Data Policy | NECOS.FM", description: "Personal Data Policy for NECOS.FM Ltd." },
  "/legal/contractor-terms": { title: "Contractor Terms | NECOS.FM", description: "Contractor Terms & Conditions for NECOS.FM Ltd." },
  "404": { title: "Page not found | NECOS.FM", description: "This page doesn't exist. For emergencies call 0247 5222 999." },
};

// Page hero copy, shared by React pages and the SEO pre-render script.
export const HEROES = {
  "/": {
    "eyebrow": "24/7 emergency call-out · UK-wide",
    "title": "When it breaks, we answer.",
    "intro": "24/7 emergency call-out, telephone triage and facilities management for build-to-rent, corporate landlords and property managers — nationwide, with local expertise."
  },
  "/about": {
    "eyebrow": "About NECOS",
    "title": "Your trusted partner when property emergencies strike.",
    "intro": "Quality, reliability and peace of mind — whenever you need it most. 24 hours a day, 7 days a week, 365 days a year."
  },
  "/about/commitment": {
    "eyebrow": "Our commitment",
    "title": "Reliability, quality, transparency and care. Every call.",
    "intro": "Whether you need emergency help or you're joining our contractor network, we're with you every step of the way."
  },
  "/about/process": {
    "eyebrow": "Our process",
    "title": "Streamlined from the first call to the final report.",
    "intro": "Property emergencies need immediate attention. Our process is designed so every situation is handled quickly, professionally and with minimal disruption."
  },
  "/about/faq": {
    "eyebrow": "Frequently asked questions",
    "title": "Straight answers to common questions.",
    "intro": "Landlord, property manager, estate agent, tenant or contractor — start here."
  },
  "/about/packages": {
    "eyebrow": "Packages",
    "title": "Tailored plans. Priced on application.",
    "intro": "When property emergencies occur, a reliable, efficient and cost-effective plan is critical. We build yours around your portfolio."
  },
  "/emergency-call-out": {
    "eyebrow": "Emergency call-out · 24/7",
    "title": "Swift, streamlined emergency response. Nationwide.",
    "intro": "Built for build-to-rent and corporate landlords, and property management companies with large UK portfolios. A 24-hour call centre, telephone triage and a network of trusted local contractors."
  },
  "/emergency-call-out/triage": {
    "eyebrow": "Our triage service",
    "title": "Real, empathetic people. Guiding callers to safe solutions.",
    "intro": "Your tenants talk to trained professionals who assess urgency and walk them through self-help steps — avoiding unnecessary contractor deployments."
  },
  "/facilities-management": {
    "eyebrow": "Complete facilities management · Nationwide",
    "title": "One partner. One platform. Complete control.",
    "intro": "From a single urgent repair to a national multi-site portfolio, we coordinate the people, systems, compliance, approvals, evidence and commercial controls that keep properties safe, compliant and well maintained."
  },
  "/facilities-management/out-of-hours": {
    "eyebrow": "Out of hours · White-label property support",
    "title": "Professional cover when your office is closed.",
    "intro": "Trained call handling, property-focused triage, remote resolution, make-safe guidance and controlled escalation — protecting residents, property and budgets outside office hours. Real people, real triage. Not an answering service."
  },
  "/facilities-management/necos-app": {
    "eyebrow": "Client technology · NECOS.APP",
    "title": "Your portfolio. Your jobs. Your approvals. Your records.",
    "intro": "Our custom-built FM platform gives you one controlled place to log issues, approve quotes, follow progress, review completion evidence and receive invoices. The goal isn't to digitise maintenance — it's visibility, consistency and control across your entire portfolio."
  },
  "/clients": {
    "eyebrow": "For clients",
    "title": "The all-in-one answer to property emergencies.",
    "intro": "A partner dedicated to protecting your investments, delighting your tenants and delivering exceptional service, every time."
  },
  "/contractors": {
    "eyebrow": "For contractors",
    "title": "Join a national network with local impact.",
    "intro": "If you're a qualified professional who takes pride in reliable, high-quality work, we'd like to hear from you. Together we can keep properties safe, 24/7."
  },
  "/contact": {
    "eyebrow": "Contact",
    "title": "Let's talk. Any time.",
    "intro": "Client, landlord, property manager, contractor or tenant — get in touch with any question about our services."
  },
  "/downloads": {
    "eyebrow": "Resources",
    "title": "Take the detail with you.",
    "intro": "Our services brochure and out of hours brochure, sent straight to your inbox. Share them with your team, your board or your procurement lead."
  },
  "/contractors/update": {
    "eyebrow": "Existing suppliers",
    "title": "Update your supplier details",
    "intro": "Keep your contact details, services, bank details and documents up to date"
  },
  "/contractors/apply": {
    "eyebrow": "Join the network",
    "title": "Supplier Application",
    "intro": "Complete the form below to apply to join our supplier network"
  },
  "/request-callout": {
    "eyebrow": "Not an emergency?",
    "title": "Request a call-out.",
    "intro": "Tell us what needs attention and we'll prioritise your request accordingly."
  },
  "/report": {
    "eyebrow": "Report an issue",
    "title": "Tell us what’s happened.",
    "intro": "Reporting an issue should be quick and calm. Our streamlined process saves time, reduces stress and gets your tenants the support they need without delay."
  },
  "/areas": {
    "eyebrow": "Areas we cover",
    "title": "Emergency property repairs across the UK.",
    "intro": "A nationwide network of vetted local contractors, coordinated by one central 24/7 triage desk. Wherever your property is, you call one number and speak to a trained call handler — day or night."
  }
};
